import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { LegalPolicy, TermsService } from './terms.service';

@Component({
  selector: 'app-terms-popup',
  templateUrl: './terms-popup.component.html',
  styleUrls: ['./terms-popup.component.scss'],
  standalone: false,
})
export class TermsPopupComponent implements OnInit {
  tcUrl = '';
  privacyUrl = '';
  termsVersion: number;
  isAccepting = false;

  constructor(
    public dialogRef: MatDialogRef<TermsPopupComponent>,
    private router: Router,
    private termsService: TermsService,
  ) {}

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.termsService
      .getLegalPolicies()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          this.tcUrl = this.getPolicyUrl(res.termsAndConditions);
          this.privacyUrl = this.getPolicyUrl(res.privacyPolicy);
          this.termsVersion = res.termsAndConditions?.version;
        },
        (err) => {},
      );
  }

  accept() {
    if (this.isAccepting || !this.termsVersion) {
      return;
    }

    this.isAccepting = true;
    this.termsService
      .accept(this.termsVersion)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          this.router.navigateByUrl('/').finally(() => {
            this.dialogRef.close();
            location.reload();
          });
        },
        (err) => {
          this.isAccepting = false;
        },
      );
  }

  preventMissingLink(event: MouseEvent, url: string) {
    if (!url) {
      event.preventDefault();
    }
  }

  private getPolicyUrl(policy: LegalPolicy): string {
    return policy?.url || policy?.fileUrl || policy?.link || '';
  }
}
